import { Compiler, inject, Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { OrganizationsService } from "../../organization/service/organizations.service";

@Injectable({
  providedIn: 'root',
})
export class ResetAllDataService {
  private orgService = inject(OrganizationsService);
  private _compiler = inject(Compiler);
  private cookie = inject(CookieService);

  reset(): void {
    localStorage.clear();
    // don't clear the session storage, look at session-expiration.service.ts
    this.cookie.deleteAll();
    this.orgService.resetAllData();

    this._compiler.clearCache();
  }
}
